import React from "react";
import Entity from "../../components/Entity";

function Promotion() {
  return (
    <Entity
      formShema={{
        fields: [{ name: "Name", propertyName: "name", type: "input" }],
      }}
    />
  );
}

export default Promotion;
